/* eslint-disable complexity */
import styled from '@emotion/styled';
import {
  Box,
  CircularProgress,
  Dialog,
  InputLabel,
  Select,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import useCoddingManualInsert from 'api/createListCodding/useCoddingManualInsert/useCoddingManualInsert';
import useGetCoddingProfile from 'api/createListCodding/useGetCoddingProfile/useGetCoddingProfile';
import useGetManualInsertDefaults from 'api/createListCodding/useGetManualInsertDefaults/useGetManualInsertDefaults';
import useInitBranchCodding from 'api/createListCodding/useInitBranchCodding/useBranchCoddingInit';
import useInsertMappingProfile from 'api/createListCodding/useMappingProfile/useInsertMappingProfile';
import useMappingProfile from 'api/createListCodding/useMappingProfile/useMappingProfile';
import useSearchMappingProfile from 'api/createListCodding/useSearchMappingProfile/useSearchMappingProfile';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import React, { useEffect, useState } from 'react';

import BranchSystemCreate from '../../../BranchSystemCreate/BranchSystemCreate';
import TryAgain from '../../../TryAgain/TryAgain';
import GalleryHeader from '../Gallery/GalleryHeader/GalleryHeader';

const CreateProductCodding = ({
  open,
  onClose,
  originGuid,
  branchGuid,
  codeType,
  profileGuid,
  onSuccess,
}) => {
  const [selectedCodding, setSelectedCodding] = useState(null);
  const [step, setStep] = useState(0);

  const [manualCodding, setManualCodding] = useState('');
  const [manualTitle, setManualTitle] = useState('');
  const [mapping, setMapping] = useState(null);

  const [selectedMapping, setSelectedMapping] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [getAllCodding, allCoddingLoading, allCoddingFailed, allCoddingData] =
    useGetCoddingProfile();

  const [init, initLoading, initData] = useInitBranchCodding();
  const [
    getManualInsertDefaults,
    getManualInsertDefaultsLoading,
    manualInsertDefaults,
  ] = useGetManualInsertDefaults();

  const [saveManual, manualLoading] = useCoddingManualInsert();

  const [searchMapping, searchMappingLoading, searchMappingData] =
    useSearchMappingProfile();

  const [
    getMappingList,
    getMappingListLoading,
    getMappingListFailed,
    mappingList,
  ] = useMappingProfile();

  const [saveMappingProfile, saveMappingProfileLoading] =
    useInsertMappingProfile({ branchGuid, originGuid });

  useEffect(() => {
    if (!open) {
      setStep(0);
      setSelectedCodding(null);
      return;
    }

    if (profileGuid) {
      setSelectedCodding(profileGuid);
      if (codeType === '1') {
        getManualInsertDefaults(profileGuid, () => changeStepBaseOnType('1'));
      } else {
        changeStepBaseOnType(codeType);
      }
      return;
    }

    getAllCodding(codeType);
  }, [open, profileGuid, codeType]);

  function handleConfirmSelected() {
    if (!selectedCodding) return;

    if (!codeType) {
      init(selectedCodding, value => {
        if (value === '1') {
          getManualInsertDefaults(selectedCodding, data => {
            changeStepBaseOnType('1');
          });
        }
        changeStepBaseOnType(value);
      });
    } else {
      if (codeType === '1') {
        getManualInsertDefaults(selectedCodding, data => {
          changeStepBaseOnType('1');
        });
      }
      changeStepBaseOnType(codeType);
    }
  }

  function changeStepBaseOnType(type) {
    switch (type) {
      case '0':
        return setStep(1);
      case '1':
        return setStep(2);
      case '2':
        getMappingList();
        return setStep(3);
      case '3':
        searchMapping(mapping?.key, '');
        return setStep(4);
      default:
        return setStep(0);
    }
  }

  function confirmSaveManual() {
    saveManual(
      {
        originGuid,
        branchGuid,
        profileGuid: selectedCodding,
        title: manualTitle,
        code: manualCodding,
        titleRequired: manualInsertDefaults?.titleRequired,
      },
      () => handleSuccess(),
    );
  }

  function confirmSaveCoddingProfile() {
    saveMappingProfile(selectedCodding, selectedMapping?.key, () =>
      handleSuccess(),
    );
  }

  function handleSuccess() {
    setManualTitle('');
    setManualCodding('');
    setMapping(null);
    onSuccess();
  }

  function searchStringMapping(e) {
    const val = e?.target?.value;
    if (val === 0) return;
    if (window.searchTimer) {
      clearTimeout(window.searchTimer);
    }
    window.searchTimer = setTimeout(
      () => searchMapping(mapping?.key, val),
      650,
    );
  }
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      keepMounted={false}
    >
      <GalleryHeader onClose={onClose} label="ثبت کدینگ" />
      <Box sx={{ p: 3, direction: 'rtl' }}>
        <Fade in={step === 0}>
          <div hidden={step !== 0}>
            {allCoddingFailed && !allCoddingLoading ? (
              <TryAgain tryAgain={() => getAllCodding()} />
            ) : null}
            <FormControl fullWidth>
              <InputLabel id="selectedCodding">نوع کدینگ پروفایل</InputLabel>
              <Select
                disabled={initLoading || getManualInsertDefaultsLoading}
                labelId="selectedCodding"
                id="selectedCodding"
                value={selectedCodding || null}
                name="selectedCodding"
                variant="outlined"
                label="نوع کدینگ پروفایل"
                onChange={e => setSelectedCodding(e.target.value)}
              >
                {allCoddingData?.map(coddingType => (
                  <MenuItem
                    dense
                    value={coddingType?.key}
                    key={coddingType?.key}
                    dir="rtl"
                  >
                    {coddingType?.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FlexCenterBox mt={3} justifyContent="center">
              <Button
                sx={{ p: '7px 30px' }}
                variant="contained"
                onClick={handleConfirmSelected}
                disabled={initLoading || getManualInsertDefaultsLoading}
              >
                ثبت
              </Button>
              <Button
                variant="text"
                disableRipple
                color="secondary"
                onClick={onClose}
              >
                انصراف
              </Button>
            </FlexCenterBox>
          </div>
        </Fade>

        <Fade in={step === 1} mountOnEnter>
          <div hidden={step !== 1}>
            <BranchSystemCreate
              onEditComplete={handleSuccess}
              createMode
              branchGuid={branchGuid}
              originGuid={originGuid}
              profileGuid={selectedCodding}
            />
          </div>
        </Fade>

        {getManualInsertDefaultsLoading ? (
          <SpinnerLoader />
        ) : (
          <Fade in={step === 2} mountOnEnter>
            <div hidden={step !== 2}>
              {manualInsertDefaults && manualInsertDefaults?.titleRequired ? (
                <TextField
                  sx={{ mb: 2 }}
                  value={manualTitle}
                  onChange={e => setManualTitle(e.target.value)}
                  label="عنوان"
                  fullWidth
                  disabled={manualLoading}
                />
              ) : null}
              <TextField
                value={manualCodding}
                onChange={e => setManualCodding(e.target.value)}
                label="کد"
                fullWidth
                disabled={manualLoading}
              />
              <FlexCenterBox mt={3} justifyContent="center">
                <Button
                  sx={{ p: '7px 30px' }}
                  variant="contained"
                  onClick={confirmSaveManual}
                  disabled={manualLoading}
                >
                  ثبت
                </Button>
                <Button
                  variant="text"
                  disableRipple
                  color="secondary"
                  onClick={() => setStep(0)}
                >
                  انصراف
                </Button>
              </FlexCenterBox>
            </div>
          </Fade>
        )}

        <Fade in={step === 3} mountOnEnter>
          <div hidden={step !== 3}>
            {getMappingListFailed && !getMappingListLoading ? (
              <TryAgain tryAgain={() => getMappingList()} />
            ) : null}
            <Autocomplete
              options={mappingList || []}
              autoHighlight
              value={mapping || null}
              getOptionLabel={option => option.value}
              noOptionsText={
                <div className="w-full flex justify-center">موردی یافت نشد</div>
              }
              renderOption={(props, option) => (
                <div {...props} dir="rtl">
                  {option.value}
                </div>
              )}
              onChange={(event, newValue) => {
                setMapping(prev => newValue);
              }}
              sx={{
                '.MuiInputBase-root': {
                  paddingRight: '9px !important',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{
                    '.MuiAutocomplete-endAdornment': {
                      right: 'unset !important',
                      left: '9px',
                    },
                    '.MuiAutocomplete-endAdornment button': {
                      mr: 0.5,
                    },
                  }}
                  label="مپینگ پروفایل"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password', // disable autocomplete and autofill
                  }}
                  className="gray-icon"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
            <FlexCenterBox mt={3} justifyContent="center">
              <Button
                sx={{ p: '7px 30px' }}
                variant="contained"
                onClick={() => changeStepBaseOnType('3')}
                disabled={!mapping?.key}
              >
                ثبت
              </Button>
              <Button
                variant="text"
                disableRipple
                color="secondary"
                onClick={() => setStep(0)}
              >
                انصراف
              </Button>
            </FlexCenterBox>
          </div>
        </Fade>

        <Fade in={step === 4} mountOnEnter>
          <div hidden={step !== 4}>
            <Autocomplete
              options={searchMappingData || []}
              autoHighlight
              value={selectedCodding || null}
              getOptionLabel={option => option.value || ''}
              noOptionsText={
                <div className="w-full flex justify-center">موردی یافت نشد</div>
              }
              loading={searchMappingLoading}
              freeSolo
              loadingText={
                <div>
                  <CircularProgress sx={{ m: 'auto' }} />
                </div>
              }
              renderOption={(props, option) => (
                <div {...props} dir="rtl">
                  {option.value}
                </div>
              )}
              onChange={(event, newValue) => {
                setSelectedMapping(newValue);
                if (newValue === null) {
                  searchStringMapping({ target: { value: '' } });
                }
              }}
              sx={{
                '.MuiInputBase-root': {
                  paddingRight: '9px !important',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{
                    '.MuiAutocomplete-endAdornment': {
                      right: 'unset !important',
                      left: '9px',
                    },
                    '.MuiAutocomplete-endAdornment button': {
                      mr: 0.5,
                    },
                  }}
                  onInput={searchStringMapping}
                  label="مپینگ پروفایل"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password', // disable autocomplete and autofill
                  }}
                  className="gray-icon"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
            <FlexCenterBox mt={3} justifyContent="center">
              <Button
                sx={{ p: '7px 30px' }}
                variant="contained"
                onClick={confirmSaveCoddingProfile}
                disabled={!selectedMapping?.key}
              >
                ثبت
              </Button>
              <Button
                variant="text"
                disableRipple
                color="secondary"
                onClick={() => setStep(3)}
              >
                انصراف
              </Button>
            </FlexCenterBox>
          </div>
        </Fade>
      </Box>
    </Dialog>
  );
};
export default CreateProductCodding;

const FlexCenterBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
`;
